import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { history } from '../../state/configureStore';
import { resolveCommunicationAdHref } from '../../utils/communicationLink';

function CommunicationAdLink({
  href,
  className,
  style,
  ariaLabel,
  tabIndex,
  children,
}) {
  const resolved = resolveCommunicationAdHref(href);

  const handleClick = useCallback((event) => {
    if (resolved.kind !== 'internal') {
      return;
    }
    event.preventDefault();
    history.push(resolved.to);
  }, [resolved]);

  if (resolved.kind === 'none') {
    return null;
  }

  const linkHref = resolved.kind === 'internal' ? resolved.to : resolved.href;

  return (
    <a
      href={linkHref}
      className={className}
      style={style}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}

CommunicationAdLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape(),
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.number,
  children: PropTypes.node,
};

CommunicationAdLink.defaultProps = {
  href: '',
  className: '',
  style: undefined,
  ariaLabel: undefined,
  tabIndex: undefined,
  children: null,
};

export default CommunicationAdLink;
